import { Guid } from "guid-typescript";
import { IField } from "../../IField";

//Generated code, do not modify

export class ActivityTypeResponse {
    id!: Guid;
    activityGroupId!: Guid;
    name!: string;
    filterable!: boolean;
    isDefaultSelected!: boolean;

    public static Fields = {
        id: { name: "id", type: "Guid" },
        activityGroupId: { name: "activityGroupId", type: "Guid" },
        name: { name: "name", type: "string" },
        filterable: { name: "filterable", type: "boolean" },
        isDefaultSelected: { name: "isDefaultSelected", type: "boolean" },
    } as Record<"id" | "activityGroupId" | "name" | "filterable" | "isDefaultSelected", IField>;
}
